import React from "react";
import { format } from "date-fns";
import logo from "../../assets/Logofile/logo (2).png";
import logo2 from "../../assets/Logofile/INDIA_Book_Of_Record_Logo.png";
import background from "../../assets/Images/Jeevandeep_Organ_donation_foundation_Logo.png";
import slogan from "../../assets/Images/slogan.png";
import signature from "../../assets/Images/signature.png";

const GovernmentCertificate = React.forwardRef(({ data }, ref) => {
  const finalData = { ...data };

  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        maxWidth: "800px",
        minHeight: "600px",
        backgroundColor: "white",
        position: "relative",
        fontFamily: "'Times New Roman', serif",
        margin: "0 auto",
        padding: "clamp(20px, 3vw, 40px)",
        boxShadow: "0 0 20px rgba(0,0,0,0.1)",
        overflow: "hidden",
      }}
    >
      <img
        src={background}
        alt="Certificate background"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          opacity: 0.1,
          zIndex: 999,
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          zIndex: 1,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          right: 20,
          bottom: 20,
          border: "8px solid #8B4513",
          borderRadius: "10px",
          background: "transparent",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 15,
            left: 15,
            right: 15,
            bottom: 15,
            border: "2px solid #DAA520",
            borderRadius: "5px",
          }}
        />

        <div
          style={{
            position: "absolute",
            top: -4,
            left: -4,
            width: "60px",
            height: "60px",
            background:
              "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwIDVDMzIuNzYxNCA1IDM1IDcuMjM4NTggMzUgMTBDMzUgMTIuNzYxNCAzMi43NjE0IDE1IDMwIDE1QzI3LjIzODYgMTUgMjUgMTIuNzYxNCAyNSAxMEMyNSA3LjIzODU4IDI3LjIzODYgNSAzMCA1WiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMTAgMzBDMTIuNzYxNCAzMCAxNSAzMi4yMzg2IDE1IDM1QzE1IDM3Ljc2MTQgMTIuNzYxNCA0MCAxMCA0MEM3LjIzODU4IDQwIDUgMzcuNzYxNCA1IDM1QzUgMzIuMjM4NiA3LjIzODU4IDMwIDEwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNNTAgMzBDNTIuNzYxNCAzMCA1NSAzMi4yMzg2IDU1IDM1QzU1IDM3Ljc2MTQgNTIuNzYxNCA0MCA1MCA0MEM0Ny4yMzg2IDQwIDQ1IDM3Ljc2MTQgNDUgMzVDNDUgMzIuMjM4NiA0Ny4yMzg2IDMwIDUwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMzAgNTVDMzIuNzYxNCA1NSAzNSA1Mi43NjE0IDM1IDUwQzM1IDQ3LjIzODYgMzIuNzYxNCA0NSAzMCA0NUMyNy4yMzg2IDQ1IDI1IDQ3LjIzODYgMjUgNTBDMjUgNTIuNzYxNCAyNy4yMzg2IDU1IDMwIDU1WiIgZmlsbD0iIzhhNDUxMyIvPgo8L3N2Zz4K')",
            backgroundSize: "contain",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: -4,
            right: -4,
            width: "60px",
            height: "60px",
            background:
              "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1zbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwIDVDMzIuNzYxNCA1IDM1IDcuMjM4NTggMzUgMTBDMzUgMTIuNzYxNCAzMi43NjE0IDE1IDMwIDE1QzI3LjIzODYgMTUgMjUgMTIuNzYxNCAyNSAxMEMyNSA3LjIzODU4IDI3LjIzODYgNSAzMCA1WiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMTAgMzBDMTIuNzYxNCAzMCAxNSAzMi4yMzg2IDE1IDM1QzE1IDM3Ljc2MTQgMTIuNzYxNCA0MCAxMCA0MEM3LjIzODU4IDQwIDUgMzcuNzYxNCA1IDM1QzUgMzIuMjM4NiA3LjIzODU4IDMwIDEwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNNTAgMzBDNTIuNzYxNCAzMCA1NSAzMi4yMzg2IDU1IDM1QzU1IDM3Ljc2MTQgNTIuNzYxNCA0MCA1MCA0MEM0Ny4yMzg2IDQwIDQ1IDM3Ljc2MTQgNDUgMzVDNDUgMzIuMjM4NiA0Ny4yMzg2IDMwIDUwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMzAgNTVDMzIuNzYxNCA1NSAzNSA1Mi43NjE0IDM1IDUwQzM1IDQ3LjIzODYgMzIuNzYxNCA0NSAzMCA0NUMyNy4yMzg2IDQ1IDI1IDQ3LjIzODYgMjUgNTBDMjUgNTIuNzYxNCAyNy4yMzg2IDU1IDMwIDU1WiIgZmlsbD0iIzhhNDUxMyIvPgo8L3N2Zz4K')",
            backgroundSize: "contain",
            transform: "rotate(90deg)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -4,
            left: -4,
            width: "60px",
            height: "60px",
            background:
              "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1zbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwIDVDMzIuNzYxNCA1IDM1IDcuMjM4NTggMzUgMTBDMzUgMTIuNzYxNCAzMi43NjE0IDE1IDMwIDE1QzI3LjIzODYgMTUgMjUgMTIuNzYxNCAyNSAxMEMyNSA3LjIzODU4IDI3LjIzODYgNSAzMCA1WiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMTAgMzBDMTIuNzYxNCAzMCAxNSAzMi4yMzg2IDE1IDM1QzE1IDM3Ljc2MTQgMTIuNzYxNCA0MCAxMCA0MEM3LjIzODU4IDQwIDUgMzcuNzYxNCA1IDM1QzUgMzIuMjM4NiA3LjIzODU4IDMwIDEwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNNTAgMzBDNTIuNzYxNCAzMCA1NSAzMi4yMzg2IDU1IDM1QzU1IDM3Ljc2MTQgNTIuNzYxNCA0MCA1MCA0MEM0Ny4yMzg2IDQwIDQ1IDM3Ljc2MTQgNDUgMzVDNDUgMzIuMjM4NiA0Ny4yMzg2IDMwIDUwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMzAgNTVDMzIuNzYxNCA1NSAzNSA1Mi43NjE0IDM1IDUwQzM1IDQ3LjIzODYgMzIuNzYxNCA0NSAzMCA0NUMyNy4yMzg2IDQ1IDI1IDQ3LjIzODYgMjUgNTBDMjUgNTIuNzYxNCAyNy4yMzg2IDU1IDMwIDU1WiIgZmlsbD0iIzhhNDUxMyIvPgo8L3N2Zz4K')",
            backgroundSize: "contain",
            transform: "rotate(270deg)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -4,
            right: -4,
            width: "60px",
            height: "60px",
            background:
              "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1zbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwIDVDMzIuNzYxNCA1IDM1IDcuMjM4NTggMzUgMTBDMzUgMTIuNzYxNCAzMi43NjE0IDE1IDMwIDE1QzI3LjIzODYgMTUgMjUgMTIuNzYxNCAyNSAxMEMyNSA3LjIzODU4IDI3LjIzODYgNSAzMCA1WiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMTAgMzBDMTIuNzYxNCAzMCAxNSAzMi4yMzg2IDE1IDM1QzE1IDM3Ljc2MTQgMTIuNzYxNCA0MCAxMCA0MEM3LjIzODU4IDQwIDUgMzcuNzYxNCA1IDM1QzUgMzIuMjM4NiA3LjIzODU4IDMwIDEwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNNTAgMzBDNTIuNzYxNCAzMCA1NSAzMi4yMzg2IDU1IDM1QzU1IDM3Ljc2MTQgNTIuNzYxNCA0MCA1MCA0MEM0Ny4yMzg2IDQwIDQ1IDM3Ljc2MTQgNDUgMzVDNDUgMzIuMjM4NiA0Ny4yMzg2IDMwIDUwIDMwWiIgZmlsbD0iIzhhNDUxMyIvPgo8cGF0aCBkPSJNMzAgNTVDMzIuNzYxNCA1NSAzNSA1Mi43NjE0IDM1IDUwQzM1IDQ3LjIzODYgMzIuNzYxNCA0NSAzMCA0NUMyNy4yMzg2IDQ1IDI1IDQ3LjIzODYgMjUgNTBDMjUgNTIuNzYxNCAyNy4yMzg2IDU1IDMwIDU1WiIgZmlsbD0iIzhhNDUxMyIvPgo8L3N2Zz4K')",
            backgroundSize: "contain",
            transform: "rotate(180deg)",
          }}
        />
      </div>

      <div
        style={{
          position: "relative",
          zIndex: 10,
          padding: "clamp(20px, 4vw, 60px)",
          height: "100%",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            overflow: "hidden",
          }}
        >
          <img
            src={logo}
            alt="Jeevandeep Logo"
            style={{
              width: "35%",
              height: "35%",
              objectFit: "contain",
            }}
          />
          <img
            src={logo2}
            alt="Jeevandeep Logo"
            style={{
              width: "25%",
              height: "25%",
              objectFit: "contain",
            }}
          />
        </div>

        <div
          style={{
            fontSize: "clamp(18px, 2.5vw, 24px)",
            fontWeight: "bold",
            color: "#1a1a1a",
            marginBottom: "8px",
            letterSpacing: "2px",
          }}
        >
          JEEVANDEEP ORGAN FOUNDATION
        </div>

        <div
          style={{
            fontSize: "clamp(11px, 1.8vw, 14px)",
            color: "#666",
            marginBottom: "30px",
            letterSpacing: "1px",
          }}
        >
          Government Recognized Organization
        </div>

        <div
          style={{
            fontSize: "clamp(18px, 3vw, 28px)",
            fontWeight: "bold",
            color: "#8B4513",
            marginBottom: "40px",
            textDecoration: "underline",
            letterSpacing: "1px",
          }}
        >
          CERTIFICATE OF ORGAN DONATION PLEDGE
        </div>

        <div style={{ marginBottom: "15px", lineHeight: "1.8" }}>
        
          <div
            style={{
              fontSize: "clamp(24px, 4vw, 36px)",
              fontWeight: "bold",
              color: "#1a1a1a",
              marginBottom: "5px",
              textTransform: "uppercase",
              borderBottom: "2px solid #DAA520",
              paddingBottom: "5px",
              display: "inline-block",
            }}
          >
            {finalData.fullName}
          </div>

          <div
            style={{
              fontSize: "18px",
              color: "#333",
              marginBottom: "20px",
            }}
          >
            Son/Daughter of <strong>{finalData.emergencyContact.fatherName}</strong>
          </div>

          <div
            style={{
              fontSize: "18px",
              color: "#333",
              marginBottom: "20px",
              lineHeight: "1.6",
            }}
          >
            has voluntarily pledged to donate organs and tissues after death
            <br />
            for the noble cause of saving human lives through organ
            transplantation.
          </div>

          {/* Personal Details */}
          <div style={{ marginBottom: "20px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)", // Changed to 5 columns
                gap: "clamp(8px, 1.5vw, 16px)",
                margin: "0 auto",
                maxWidth: "1000px",
                width: "100%",
              }}
            >
              <InfoCard
                label="Date of Birth"
                value={
                  finalData.dateOfBirth
                    ? format(new Date(finalData.dateOfBirth), "dd/MM/yyyy")
                    : "-"
                }
              />
              <InfoCard label="Gender" value={finalData.gender} />
              <InfoCard label="Blood Group" value={finalData.bloodGroup} />
              <InfoCard label="Contact" value={finalData.mobileNumber} />
            </div>

            {/* Organs and Tissues Section */}
            <div style={{ marginBottom: "5px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px",
                  margin: "0 auto",
                  maxWidth: "800px",
                  padding: "12px",
                  border: "1px solid #DAA520",
                  borderRadius: "6px",
                  background: "rgba(255, 255, 255, 0.9)",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: "clamp(16px, 2vw, 20px)",
                      color: "#8B4513",
                      fontWeight: "bold",
                      marginBottom: "8px",
                      borderBottom: "2px solid #DAA520",
                      paddingBottom: "4px",
                      textAlign: "center",
                    }}
                  >
                    Organs Pledged
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      justifyContent: "center",
                    }}
                  >
                    {Object.entries(finalData.organs || {})
                      .filter(([_, v]) => v)
                      .map(([organ]) => (
                        <div
                          key={organ}
                          style={{
                            padding: "4px 12px",
                            background: "#f8f8f8",
                            borderRadius: "15px",
                            fontSize: "clamp(12px, 1.5vw, 14px)",
                            color: "#1a1a1a",
                            fontWeight: "600",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                            border: "1px solid #DAA520",
                          }}
                        >
                          {organ}
                        </div>
                      ))}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "clamp(16px, 2vw, 20px)",
                      color: "#8B4513",
                      fontWeight: "bold",
                      marginBottom: "8px",
                      borderBottom: "2px solid #DAA520",
                      paddingBottom: "4px",
                      textAlign: "center",
                    }}
                  >
                    Tissues Pledged
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      justifyContent: "center",
                    }}
                  >
                    {Object.entries(finalData.tissues || {})
                      .filter(([_, v]) => v)
                      .map(([tissue]) => (
                        <div
                          key={tissue}
                          style={{
                            padding: "4px 12px",
                            background: "#f8f8f8",
                            borderRadius: "15px",
                            fontSize: "clamp(12px, 1.5vw, 14px)",
                            color: "#1a1a1a",
                            fontWeight: "600",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                            border: "1px solid #DAA520",
                          }}
                        >
                          {tissue}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Section */}
            <div
              style={{
                marginTop: "25px",
                borderTop: "2px solid #DAA520",
                paddingTop: "10px",
              }}
            >
              {/* Registration Date and Signature */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >

                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  <img
                    src={signature}
                    alt="Authorized Signature"
                    style={{
                      height: "80px",
                      marginBottom: "5px",
                    }}
                  />
                  <div
                    style={{
                      fontSize: "clamp(12px, 1.8vw, 14px)",
                      color: "#333",
                      borderTop: "1px solid #666",
                      width: "200px",
                      marginTop: "5px",
                    }}
                  >
                    Authorized Signature
                  </div>
                </div>
              </div>

              {/* Slogan Image */}
              <div
                style={{
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                <img
                  src={slogan}
                  alt="Slogan"
                  style={{
                    maxWidth: "600px",
                    height: "auto",
                  }}
                />
              </div>

              {/* Contact Information */}
              <div
                style={{
                  margin: "20px auto",
                  padding: "15px",
                  maxWidth: "800px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "clamp(13px, 1.6vw, 15px)",
                    color: "#333",
                    lineHeight: "1.6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px"
                  }}
                >
                  <svg 
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2"
                    style={{ flexShrink: 0 }}
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  +91 99784 41000
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const InfoCard = ({ label, value }) => (
  <div
    style={{
      background: "#fff",
      padding: "clamp(8px, 1.5vw, 12px)",
      borderRadius: "6px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      textAlign: "center",
    }}
  >
    <div
      style={{
        fontSize: "clamp(10px, 1.5vw, 14px)",
        color: "#666",
        marginBottom: "4px",
      }}
    >
      {label}
    </div>
    <div
      style={{
        fontSize: "clamp(11px, 1.6vw, 14px)",
        color: "#333",
        fontWeight: "bold",
      }}
    >
      {value}
    </div>
  </div>
);

export default GovernmentCertificate;
